import styled from 'styled-components';

const ColorVariantLabelContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export default ColorVariantLabelContainer;
